export default __webpack_public_path__ + "static/img1-8f705a9c318384936bce989a694db37f.png";